import {useNavigate} from "react-router-dom";
import {useMutation, useQuery} from "@tanstack/react-query";
import {deleteMedia, getMediaNew} from "../../../../data/api/Customer";
import {Box, Center, HStack, IconButton, Image, Text, VStack, Wrap} from "@chakra-ui/react";
import {scrollbarCss} from "../../../../theme/theme";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {BASE_URL, usePaginationData} from "../../../../utils/Utils";
import {MediaModelNew} from "../../../../data/model/Product";
import {
    PaginationInputComponent
} from "../../../../components/molecules/PaginationInputComponent/PaginationInputComponent";
import {ArrowBackIcon, DeleteIcon} from "@chakra-ui/icons";
import {
    Admin,
    BooleanField,
    BooleanInput,
    DataProvider,
    Edit,
    fetchUtils,
    GetOneParams,
    Layout,
    List,
    Resource,
    SaveButton,
    Show,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
    useDelete,
    useListController,
    useRedirect
} from "react-admin";
import {adminHttpClient} from "../../../../components/organisms/OrdersAdmin/OrdersAdmin";
import {useDialogStore} from "../../../../store/useAlertDialog";
import jsonServerProvider from "ra-data-json-server";
import polyglotI18nProvider from "ra-i18n-polyglot";
import {createTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {SectionHeader} from "../../../../components/molecules/SectionHeader/SectionHeader";
import {FilterSidebar} from "../../../../components/molecules/FilterSidebar/FilterSidebar";
import {useMediaStore} from "../../../../store/use-media-store";
import emptyImage from "../../../../assets/images/empty-state-wine.png";
import {EmptyPage} from "../../../../components/organisms/EmptyPage/EmptyPage";

const italianMessages = require("ra-language-italian");

const dataProvider = jsonServerProvider(BASE_URL, adminHttpClient);
const i18nProvider = polyglotI18nProvider(() => italianMessages, "it");

const theme = createTheme({
    palette: {
        background: {
            default: "#f5fbf5"
        }
    },
    components: {
        MuiToolbar: {
            styleOverrides: {
                root: {
                    display: 'none'
                }
            }
        }
    },
});

const MediaListCustom = (props: any) => {
    const {data: controllerData, isLoading} = useListController(props);
    const data: MediaModelNew[] | undefined = controllerData as (MediaModelNew[] | undefined);

    const gridRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = useState({pageSize: 10, page: 0});

    useEffect(() => {
        const calculatePageSize = () => {
            if (gridRef.current) {
                const availableHeight = gridRef.current.clientHeight;
                const rowHeight = 52; // Altezza stimata di una riga in MUI DataGrid
                const calculatedPageSize = Math.max(1, Math.floor(availableHeight / rowHeight));
                setPaginationModel(prev => ({...prev, pageSize: calculatedPageSize}));
            }
        };

        calculatePageSize();

        window.addEventListener("resize", calculatePageSize);
        return () => window.removeEventListener("resize", calculatePageSize);
    }, []);

    const {showDialog, closeDialog} = useDialogStore();
    const [deleteOne] = useDelete();

    const columns = [
        {
            field: 'src', headerName: 'Media', flex: 1, renderCell: (params: any) => {
                return (
                    // <div style={{width: 100, height: 52}}>
                    <Image fallbackSrc={emptyImage} marginX={"auto"} src={params.row.url} width={"52px"} height={"52px"}
                           objectFit={"contain"}/>
                    // </div>
                )
            }
        },
        {field: 'id', headerName: 'ID', flex: 1},
        {field: 'name', headerName: 'Nome File', flex: 1},  // Campo per nome del file
        {field: 'mediaType', headerName: 'Tipo Media', flex: 1},  // Campo per tipo di media
        // {
        //     field: 'fileSize',
        //     headerName: 'Dimensione',
        //     flex: 1,
        //     renderCell: (params: any) => `${params.value} KB`,  // Visualizza la dimensione del file
        // },
        {
            field: 'actions',
            headerName: 'Azioni',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                return (
                    <div>
                        <IconButton fontSize={"20px"} onClick={() => showDialog({
                            title: "Elimina media",
                            description: "Sei sicuro di voler eliminare questo media?",
                            cancelButtonText: "Annulla",
                            confirmButtonText: "Elimina",
                            onPressCancelButton: () => closeDialog(),
                            onConfirmButtonClick: () => {
                                deleteOne('media', {id: params.row.id}).then(() => {
                                    closeDialog();
                                });
                            }
                        })} aria-label={"Delete"}>
                            <DeleteIcon color="error"/>
                        </IconButton>
                    </div>
                );
            },
        }
    ];

    const trasformData = (data: MediaModelNew[]) => {
        return data?.map((media: MediaModelNew) => ({
            id: media.id,
            name: media.name,
            mediaType: media.mediaType,
            isMain: media.isMain,
            url: media.url,
        }));
    }

    const rows = trasformData(data || []);

    if (!data || data.length === 0) {
        return (
            // <Center h="full">
            //     <VStack spacing={4}>
            //         <Text fontSize="lg" color={"primary.400"} fontWeight="bold">Nessun media trovato</Text>
            //         <Text>Prova a cambiare i filtri o ad aggiungere nuovi utenti.</Text>
            //     </VStack>
            // </Center>
            <EmptyPage isLoading={isLoading} title={"Nessun media trovato"}
                       description={"Prova a cambiare i filti o ad aggiungere nuovi utenti"}/>
        );
    }

    return (
        <List {...props}>
            <div ref={gridRef} style={{display: "flex", flexDirection: "column", height: "100%", width: "100%"}}>
                <DataGrid
                    sx={{
                        '& .MuiDataGrid-columnHeaders': {
                            background: 'white !important',
                        },
                        '& .MuiDataGrid-row--borderBottom': {
                            background: 'white !important',
                        },
                        '& .MuiToolbar-root': {
                            display: 'flex !important'
                        }
                    }}
                    pagination
                    paginationMode="client"
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    // rowHeight={100}
                    rows={rows}
                    columns={columns}
                />
            </div>
        </List>
    );
};

const customDataProvider: DataProvider = {
    ...dataProvider,

    getList: async (resource, params) => {
        const {page, perPage} = params.pagination || {};
        const {field, order} = params.sort || {};

        const query = {
            _start: ((page || 1) - 1) * (perPage || 10),
            _end: (page || 1) * (perPage || 10),
            _sort: field,
            _order: order,
        };

        const url = `${BASE_URL}/medias?${fetchUtils.queryParameters(query)}`;

        return adminHttpClient(url).then(({headers, json}) => {
            const total = headers.get("X-Total-Count");

            return {
                data: json.map((item: any) => ({id: item.id, ...item})),
                total: total ? parseInt(total, 10) : json.length,
            };
        });
    },
    getOne: (resource: string, params: GetOneParams) => {
        const url = `${BASE_URL}/medias/${params.id}`;  // Modifica il path per il media
        return adminHttpClient(url).then(({json}) => {
            if (!json || !json.id) {
                throw new Error("Invalid response format: missing 'id'");
            }
            return {data: json};
        });
    },

    update: (resource, params) => {
        const url = `${BASE_URL}/medias/${params.id}`;  // Modifica il path per il media
        return adminHttpClient(url, {
            method: "PUT",
            body: JSON.stringify(params.data),
        }).then(({json}) => {
            if (!json || !json.data || !json.data.id) {
                console.error("Invalid response format for update:", json);
                return {data: {id: params.id, ...params.data}}; // Fallback
            }
            return {data: json.data};
        });
    },

    create: (resource, params) => {
        const url = `${BASE_URL}/medias`;  // Modifica il path per il media
        return adminHttpClient(url, {
            method: "POST",
            body: JSON.stringify(params.data),
        }).then(({json}) => {
            if (!json || !json.data || !json.data.id) {
                throw new Error("Invalid response format for create");
            }
            return {data: json.data};
        });
    },

    delete: (resource, params) => {
        const url = `${BASE_URL}/medias/${params.id}`;  // Modifica il path per il media
        return adminHttpClient(url, {method: "DELETE"}).then(({json}) => {
            return {data: json?.data ?? {...params.previousData}};
        });
    },

    deleteMany: (resource, params) => {
        const url = `${BASE_URL}/medias`;  // Modifica il path per il media
        return adminHttpClient(url, {
            method: "DELETE",
            body: JSON.stringify({ids: params.ids}),
        }).then(() => ({data: params.ids}));
    },

    updateMany: (resource, params) => {
        const url = `${BASE_URL}/medias`;  // Modifica il path per il media
        return adminHttpClient(url, {
            method: "PUT",
            body: JSON.stringify({ids: params.ids, data: params.data}),
        }).then(({json}) => {
            if (!json || !Array.isArray(json.data)) {
                throw new Error("Invalid response format for updateMany");
            }
            return {data: json.data.map((item: any) => item.id)};
        });
    },
};

const CustomLayout = (props: any) => {
    const {searchText, setSearchText} = useMediaStore();

    return (
        <HStack w={"100%"} h={"100%"} overflow={"hidden"}>
            <VStack width={"70%"} maxWidth={"70%"} overflow={"hidden"} h={"100%"} pt={"24px"}>

                <SectionHeader title={"Media"}/>
                <HStack alignSelf={'stretch'} flex={1} overflowY={'auto'} overflowX={'auto'}>
                    <Layout appBar={() => null} appBarAlwaysOn={false}
                            sidebar={() => null} {...props} />
                </HStack>
            </VStack>
            <FilterSidebar
                searchProps={{
                    placeholder: "Inserisci cosa vuoi cercare",
                    searchInput: searchText,
                    onChangeText: setSearchText
                }}
                buttons={{
                    cancel: {
                        text: "Annulla",
                        onClick: () => {
                            setSearchText("")
                        }
                    }
                }}
                stackProps={{
                    width: "30%",
                    height: '100%',
                    alignSelf: 'stretch',
                    backgroundColor: "surfaceContainer.light",
                }}/>
        </HStack>
    )
};

export default function ImagePage() {
    return (
        <Admin dataProvider={customDataProvider} basename={'/media'} i18nProvider={i18nProvider} layout={CustomLayout} theme={theme}
               title={"Media"}>
            <Resource name="medias" hasShow list={(props) => MediaListCustom(props)} edit={MediaEdit} show={MediaShow}/>
        </Admin>
    );
}

const MediaEdit = (props: any) => {
    const redirect = useRedirect();

    return (
        <VStack w={"full"} h={"full"} alignItems={'stretch'}>
            <HStack alignItems={"center"} p={"16px"} alignSelf={'flex-start'} _hover={{
                backgroundColor: "tertiary.200",
                borderRadius: "16px",
            }} cursor={"pointer"} onClick={() => {
                redirect("/medias");
            }}>
                <ArrowBackIcon/>
                <Text fontWeight={"bold"}>Indietro</Text>
            </HStack>
            <Edit {...props}>
                <SimpleForm sx={{maxWidth: 600, mx: "auto"}}>
                    <TextInput source="id" label="ID" contentEditable={false} sx={{width: '100%'}}/>

                    <TextInput source="name" label="Nome" sx={{width: '100%'}}/>

                    <TextInput source="url" label="URL" sx={{width: '100%'}}/>

                    <TextInput source="mediaType" label="Tipo Media" sx={{width: '100%'}}/>

                    <BooleanInput source="isMain" label="Media Principale" sx={{width: '100%'}}/>

                    <SaveButton sx={{width: '100%', mt: 2}} label={"SALVA"}/>
                </SimpleForm>
            </Edit>
        </VStack>
    );
};

const MediaShow = (props: any) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" label="ID Media"/>

                <TextField source="name" label="Nome"/>

                <TextField source="url" label="URL"/>

                <TextField source="mediaType" label="Tipo Media"/>

                <BooleanField source="isMain" label="Media Principale"/>
            </SimpleShowLayout>
        </Show>
    );
};

export function ImagePageOld() {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);

    const userType = localStorage.getItem("userType");

    const response = useQuery({
        queryKey: ['get-images', page],
        queryFn: () => getMediaNew(userType || "seller", page),
        refetchOnWindowFocus: "always",
    });

    const {mutateAsync} = useMutation({
        mutationKey: ['delete-media'],
        mutationFn: ({id, url}: {id: string, url: string}) => deleteMedia(id, url),
    });

    const {
        data: mediaList,
        totPage,
        refetch
    } = usePaginationData<MediaModelNew[]>(response);

    return (
        <VStack w={"100%"} h={"100%"} pt={"24px"} alignItems={"flex-start"} overflowX={"hidden"}
                overflowY={"hidden"}>
            <HStack w={"100%"}>
                <Text fontSize={"24px"} fontWeight={"bold"} ms={"24px"}>Media</Text>

                <PaginationInputComponent setPage={setPage} page={page} totPage={totPage}/>
            </HStack>

            <Box mt={"18px"} mx={"24px"} alignSelf={"stretch"} backgroundColor={"surfaceContainer.light"}
                 borderRadius={"16px"} overflowX={"hidden"} mb={"72px"}
                 css={scrollbarCss({marginLeft: 0, marginRight: 0})}>
                <Wrap spacing={"24px"} p={"24px"} justifyContent={"space-evenly"}>
                    {mediaList?.map(value =>
                        <Box borderRadius={24} position={'relative'} w={"200px"} h={"200px"} overflow={"hidden"}
                             onClick={() => {
                                 mutateAsync({id: value.id || '', url: value.url || ''}).then(() => refetch());
                             }}>
                            <Image src={value.url} w={"100%"} h={"100%"} objectFit={"cover"}/>
                            <IconButton aria-label={"delete"} zIndex={5} icon={<DeleteIcon/>} position={'absolute'}
                                        top={'8px'} right={'8px'}/>
                        </Box>
                    )}
                </Wrap>
            </Box>
        </VStack>
    )
}
